import { SoftwareManagementTerminateEmployeesDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface QueryParameters {
  employeeIds: [number]
}

export const useTerminateEmployees = () => {
  const [terminateEmployees, { loading }] = useMutation(
    SoftwareManagementTerminateEmployeesDocument,
    {
      extractorFn: (data) =>
        data.softwareManagementMutations
          .terminateEmployeesSoftwaremanagementEmployeeSoftwareMembership,
    }
  )

  return {
    delete(params: QueryParameters) {
      return terminateEmployees({
        variables: { employeeIds: params.employeeIds },
      })
    },
    loading,
  }
}
